export type BuiltinFieldId =
  | "name"
  | "email"
  | "phone"
  | "country"
  | "state"
  | "cv";
export type CustomFieldType =
  | "text"
  | "textarea"
  | "number"
  | "file"
  | "select"
  | "radio";

export type FormField = {
  id: string;
  type: "builtin" | CustomFieldType;
  builtinId?: BuiltinFieldId;
  label: string;
  placeholder?: string;
  required: boolean;
  enabled: boolean;
  stepId: string;
  order: number;
  options?: string[];
};

export type FormStep = {
  id: string;
  title: string;
  order: number;
};

export type FormConfig = {
  steps: FormStep[];
  fields: FormField[];
};

export const BUILTIN_CATALOGUE: {
  id: BuiltinFieldId;
  label: string;
  defaultRequired: boolean;
}[] = [
  { id: "name", label: "Full Name", defaultRequired: true },
  { id: "email", label: "Email Address", defaultRequired: true },
  { id: "phone", label: "Phone Number", defaultRequired: false },
  { id: "country", label: "Country", defaultRequired: false },
  { id: "state", label: "State / Province", defaultRequired: false },
  { id: "cv", label: "CV / Resume (PDF only)", defaultRequired: true },
];

export const DEFAULT_FORM_CONFIG: FormConfig = {
  steps: [{ id: "step_default", title: "Your Application", order: 0 }],
  fields: [
    {
      id: "builtin:name",
      type: "builtin",
      builtinId: "name",
      label: "Full Name",
      required: true,
      enabled: true,
      stepId: "step_default",
      order: 0,
    },
    {
      id: "builtin:email",
      type: "builtin",
      builtinId: "email",
      label: "Email Address",
      required: true,
      enabled: true,
      stepId: "step_default",
      order: 1,
    },
    {
      id: "builtin:phone",
      type: "builtin",
      builtinId: "phone",
      label: "Phone Number",
      required: false,
      enabled: true,
      stepId: "step_default",
      order: 2,
    },
    {
      id: "builtin:country",
      type: "builtin",
      builtinId: "country",
      label: "Country",
      required: false,
      enabled: true,
      stepId: "step_default",
      order: 3,
    },
    {
      id: "builtin:state",
      type: "builtin",
      builtinId: "state",
      label: "State / Province",
      required: false,
      enabled: true,
      stepId: "step_default",
      order: 4,
    },
    {
      id: "builtin:cv",
      type: "builtin",
      builtinId: "cv",
      label: "CV / Resume (PDF only)",
      required: true,
      enabled: true,
      stepId: "step_default",
      order: 5,
    },
  ],
};

export const NIGERIAN_STATES = [
  "Abia",
  "Adamawa",
  "Akwa Ibom",
  "Anambra",
  "Bauchi",
  "Bayelsa",
  "Benue",
  "Borno",
  "Cross River",
  "Delta",
  "Ebonyi",
  "Edo",
  "Ekiti",
  "Enugu",
  "FCT",
  "Gombe",
  "Imo",
  "Jigawa",
  "Kaduna",
  "Kano",
  "Katsina",
  "Kebbi",
  "Kogi",
  "Kwara",
  "Lagos",
  "Nasarawa",
  "Niger",
  "Ogun",
  "Ondo",
  "Osun",
  "Oyo",
  "Plateau",
  "Rivers",
  "Sokoto",
  "Taraba",
  "Yobe",
  "Zamfara",
];


